import { useCallback, useMemo, useState } from 'react'

import { type IModalDialog } from './ModalDialog'

interface UseModalDialogOptions {
  onClose?: IModalDialog['onClose']
}

type UseModalDialogReturn = [() => void, () => void, { open: boolean }]

export const useModalDialog = (
  options: UseModalDialogOptions = {}
): UseModalDialogReturn => {
  const { onClose } = options

  const [open, setOpen] = useState(false)

  const openModal = useCallback(() => {
    setOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setOpen(false)
  }, [])

  const modalStates = useMemo(
    () => ({ open, onClose: onClose || closeModal }),
    [open, onClose, closeModal]
  )

  return [openModal, closeModal, modalStates]
}
